/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardComplianceSeverity {
    getFixupPrototypeFunction() { return SecurityDashboardComplianceSeverity.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardComplianceSeverity>): SecurityDashboardComplianceSeverity {
        let obj = Object.assign(new SecurityDashboardComplianceSeverity(), model);
        SecurityDashboardComplianceSeverity.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardComplianceSeverity>): SecurityDashboardComplianceSeverity {
        if (!model) return null;
        return SecurityDashboardComplianceSeverity.newInstance(<SecurityDashboardComplianceSeverity> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardComplianceSeverity) {
        if (!obj) return;

        models.SecurityDashboardComplianceSeverity.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardComplianceSeverity): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardComplianceSeverity.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total === undefined) {
            this.total = 0;
        }
        if (this.violations === undefined) {
            this.violations = 0;
        }
    }

    /**
     * Total Severity Count
     */
    total: number;

    /**
     * Total Violations Count
     */
    violations: number;

}
